/** Full-screen loader shown before cross-origin navigation to Studio. Survives React teardown. */
export function paintStudioRedirectShell(message = 'Opening Studio…'): void {
  if (document.getElementById('studio-redirect-shell')) return;

  const shell = document.createElement('div');
  shell.id = 'studio-redirect-shell';
  shell.setAttribute('role', 'status');
  shell.setAttribute('aria-live', 'polite');
  shell.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:2147483647',
    'display:flex',
    'flex-direction:column',
    'align-items:center',
    'justify-content:center',
    'gap:18px',
    'background:#0a0f1e',
    'color:#f8fafc',
    'font-family:Inter,system-ui,sans-serif',
  ].join(';');

  const spinner = document.createElement('div');
  spinner.setAttribute('aria-hidden', 'true');
  spinner.style.cssText = [
    'width:56px',
    'height:56px',
    'border-radius:50%',
    'background:conic-gradient(from 90deg,#14b8a6 0%,#2dd4bf 45%,rgba(20,184,166,.15) 70%,transparent 72%)',
    '-webkit-mask:radial-gradient(farthest-side,transparent calc(100% - 6px),#000 calc(100% - 5px))',
    'mask:radial-gradient(farthest-side,transparent calc(100% - 6px),#000 calc(100% - 5px))',
    'animation:studioRedirectSpin 1.1s linear infinite',
  ].join(';');

  const text = document.createElement('p');
  text.textContent = message;
  text.style.cssText = 'margin:0;font-size:16px;font-weight:600;color:#94a3b8';

  if (!document.getElementById('studio-redirect-spin-style')) {
    const style = document.createElement('style');
    style.id = 'studio-redirect-spin-style';
    style.textContent = '@keyframes studioRedirectSpin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
  }

  shell.append(spinner, text);
  document.body.appendChild(shell);
}

/** Remove the pre-redirect shell (e.g. when the Academy page is restored from bfcache). */
export function clearStudioRedirectShell(): void {
  document.getElementById('studio-redirect-shell')?.remove();
}

let bfcacheRestoreHandlerRegistered = false;

/**
 * Reload when Chrome restores Academy from bfcache (e.g. Back from Studio).
 * Avoids reconciling a frozen launch modal whose FocusTrap has no tabbable nodes.
 */
export function registerStudioRedirectShellCleanup(): void {
  if (bfcacheRestoreHandlerRegistered || typeof window === 'undefined') return;
  bfcacheRestoreHandlerRegistered = true;
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload();
  });
}
